module.exports = __webpack_public_path__ + "assets/img/1-3.6565fcf7.png";